import { z } from 'zod'

type ResetPasswordFormData = {
  token: string | null
  password: string
  confirmPassword: string
}

const passwordSchema = z
  .string()
  .min(8, 'min_length')
  .max(70, 'max_length')
  .regex(/[A-Z]/, 'one_uppercase_letter')
  .regex(/[\W_]/, 'one_special_char')

const resetPasswordFormSchema = z
  .object({
    token: z.string(),
    password: passwordSchema,
    confirmPassword: z.string()
  })
  .refine(data => data.password === data.confirmPassword, {
    message: 'passwords_do_not_match',
    path: ['confirmPassword']
  })

export const validateResetPasswordForm = (data: ResetPasswordFormData) => {
  return resetPasswordFormSchema.safeParse(data)
}
